import { Component, OnInit } from "@angular/core";
import { CompanyService } from "../../../services/company.service";
import { Page } from "../../../models/paging/page";
import { Router } from "@angular/router";
import { saveAs as importedSaveAs } from "file-saver";
import { ModalService } from "../../../services/modal.service";
import { Audit_Log } from "../../../models/audit_log";
import { ColumnService } from "../../../services/ColumnService";
import { AuthService } from "../../../services/auth.service";

@Component({
  selector: "app-companies",
  templateUrl: "./companies.component.html",
  styleUrls: ["./companies.component.css"],
})
export class CompaniesComponent implements OnInit {
  modalService: ModalService;

  filter: any = {
    name: "",
    quick_Search: "",
  };

  client;

  availableOptions: string[] = [
    "Company Id",
    "Customer Name",
    "Account #",
    "Location",
    "Address 2",
    "Address 3",
    "Address 4",
    "County",
    "Postcode",
    "Telephone",
    "Fax",
    "Email",
    "Customer Type",
    "Expired",
    "History",
    "Edit",
  ];

  selectedOptions: string[] = [
    "Customer Name",
    "Account #",
    "Location",
    "County",
    "Telephone",
    "Customer Type",
    "Expired",
    "History",
    "Edit",
  ];

  company_Id = 0;
  entity = "";
  showHistory: boolean = false;

  page = new Page();
  rows = Array<any>();
  init: boolean;
  constructor(
    authService: AuthService,
    private companyService: CompanyService,
    modalService: ModalService,
    private router: Router,
    private columnService: ColumnService
  ) {
    this.page.pageNumber = 0;
    this.page.size = 10;
    this.page.sortOrder = "desc";
    this.page.sortBy = "";
    this.client = authService.currentUser.value;
    this.modalService = modalService;
  }

  ngOnInit() {
    this.getcolumns();
    this.loadTable(this.page);
    this.init = true;
  }

  edit(row) {
    this.router.navigate(["administration/companies/manage"], {
      queryParams: { id: row.id },
    });
  }

  // ###################################
  // TABLE
  // ###################################
  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
    this.loadTable(this.page);
  }

  onSort(event) {
    if (event.column.prop == "") {
      return false;
    }

    this.page.sortOrder = event.newValue;
    this.page.sortBy = event.column.prop;
    this.loadTable(this.page);
  }

  loadTable(page: Page) {
    this.companyService
      .getResults(this.page, this.filter.name, this.filter.quick_Search)
      .then((pagedData) => {
        this.page = pagedData.page;
        this.rows = pagedData.data;

        if (this.init) {
          this.gotoTop();
          this.init = false;
        }
      });
  }

  createCompany() {
    this.router.navigate(["administration/customer_management/manage"]);
  }

  editCompany(row: any) {
    this.router.navigate(["administration/customer_management/manage"], {
      queryParams: {
        company_Id: row.company_Id,
      },
    });
  }

  openAuditHistoryPopup(row) {
    this.showHistory = true;
    this.company_Id = row.company_Id;
    this.entity = "Companies";
    this.modalService.open("popup-audit-log-history");
  }

  closeAuditHistoryPopup() {
    this.showHistory = false;
    this.modalService.close("popup-audit-log-history");
  }

  generateExcel() {
    this.companyService.getExcel(this.page, this.filter.name).then((data) => {
      importedSaveAs(data, "Customers.xlsx");
    });
  }

  gotoTop() {
    console.log("GOTO TOP");
    // window.scrollTo(-9999,-99999);
    let top = document.getElementById("top");
    console.log(top);
    if (top !== null) {
      top.scrollIntoView(true);
      //  document.getElementById("top").scrollTop -= 99999;
      top = null;
    }
  }

  handleSelectedColumns(selectedOptions: string[]): void {
    console.log("triggered");
    this.selectedOptions = selectedOptions;
    this.saveSelection();
  }

  getcolumns() {
    console.log("current user", this.client.userId);

    this.columnService
      .getColumns(this.client.userId, "companiesManagement")
      .then((data) => {
        if (data.columns != null) {
          this.selectedOptions = this.availableOptions.filter((c) => {
            return data.columns.includes(c);
          });
        }
      });
  }

  saveSelection() {
    this.columnService
      .save(this.client.userId, "companiesManagement", this.selectedOptions)
      .then((data) => {});
  }

  loadLocations(row: any) {
    console.log('Navigating with companyId:', row.company_Id);
    this.router.navigate(['administration/location_management'], {
      queryParams: { companyId: row.company_Id },
    });
  }
}
